var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "70mm",
    height: "78mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 7000 7800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5684 28l-5451 0 -210 0 0 210 0 3804 0 627 0 690 0 2060 0 210 211 0 1741 0 379 0 290 0 630 0 289 0 379 0 712 0 0 -421 -712 0 -379 0 -289 0 -630 0 -290 0 -379 0 -1419 0 -112 0 0 -112 0 -6536 0 -111 112 0 4806 0 111 0 0 111 0 3729 421 0 0 -4051 0 -210 -210 0zm-1543 4498l-886 0 -836 0 -1166 0 0 418 1166 0 836 0 886 0 0 -418zm498 -1144l-3399 0 0 418 3399 0 0 -418zm0 -1145l-3399 0 0 419 3399 0 0 -419zm1059 2659l1175 1257 118 126 -118 126 -1166 1247 -270 -252 870 -930 -2414 0 0 -371 2424 0 -890 -952 271 -251z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSends);
export default __webpack_public_path__ + "static/media/sends.840d12b3e78a836023aea8c1827e3d5b.svg";
export { ForwardRef as ReactComponent };